export const DASHBOARD_ACTION_BUTTON_WIDTH = '114px';
